import React, { Component } from "react";
import { reduxForm } from "redux-form";
import Grid from "@react/react-spectrum/Grid/js/Grid";
import { Table, THead, TH, TD, TBody, TR } from "@react/react-spectrum/Table";
import DataSection from "../../comps/DataSection/DataSection";
import formFields from "../config/formFields";
import Button from "@react/react-spectrum/Button";
import Dialog from "@react/react-spectrum/Dialog";
import Wait from "@react/react-spectrum/Wait";
import Heading from "@react/react-spectrum/Heading";
import { Provider, connect } from "react-redux";
import { unregisterField, getFormValues } from "redux-form";
import store from "../../store";
import { Translate } from "react-redux-i18n";
import { GridColumn, GridRow } from "@react/react-spectrum/Grid";
// import geoPolData from '../config/geoPolData';
import Pagination from "@react/react-spectrum/Pagination";
import throwError, { toastPartnerApiFailure } from "../../comps/errorToast";
import SaveNExit from "./save_n_ext";
import { getContacts } from "../utils/utils";

class AddContacts extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      popupValidation: {},
      popupMode: null,
      contactSection1: [],
      contactSection2: [],
      contact_suffix: [],
      current_item: null,
      isLoading: true,
      currentPage: 1,
      noOfContacts: 0,
      sectionValidation: { hasCoc: false },
      hasCoc: false,
    };
    this.maxPageSize = 10;
  }

  isCOCValidateRequired = this.props.isCOCValidateRequired;

  updateValidation = (name, value) => {
    let sectionValidation = this.state.sectionValidation;
    sectionValidation[name] = value;
    this.setState({ sectionValidation: sectionValidation });
  };

  updateHasCocValidationStatus = (status) => {
    if (!this.isCOCValidateRequired) {
      this.updateValidation("hasCoc", true);
    } else {
      this.updateValidation("hasCoc", status);
    }
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    let initialFormStates = this.props.formStates;
    if (initialFormStates["contacts_loaded"]) {
      this.setState({
        contact_suffix: initialFormStates["contact_suffix"],
        noOfContacts: parseInt(initialFormStates["noOfContacts"]),
        hasCoc: initialFormStates["hasCoc"],
        isLoading: false,
        currentPage: !isNaN(initialFormStates["currentPage"])
          ? initialFormStates["currentPage"]
          : 1,
      });
      this.updateHasCocValidationStatus(initialFormStates["hasCoc"]);
    }
  }

  componentDidUpdate(prevProps) {
    this.setStatesAfterContactLoad(prevProps);
  }

  setStatesAfterContactLoad = (prevProps) => {
    let initialFormStates = this.props.formStates;
    // console.log(this.props.formStates.contacts_loaded +' '+ prevProps.formStates.contacts_loaded);
    if (
      this.props.formStates.contacts_loaded &&
      (prevProps.formStates.contacts_loaded == undefined ||
        !prevProps.formStates.contacts_loaded)
    ) {
      let isLoading = true;
      if (initialFormStates["contacts_loaded"]) {
        isLoading = false;
      }
      this.setState({
        contact_suffix: initialFormStates["contact_suffix"]
          ? initialFormStates["contact_suffix"]
          : this.state.contact_suffix,
        noOfContacts: initialFormStates["noOfContacts"]
          ? parseInt(initialFormStates["noOfContacts"])
          : this.state.noOfContacts,
        hasCoc: initialFormStates["hasCoc"]
          ? initialFormStates["hasCoc"]
          : this.state.hasCoc,
        isLoading: isLoading,
        contacts_loaded: initialFormStates["contacts_loaded"],
      });
      this.updateHasCocValidationStatus(initialFormStates["hasCoc"]);
    }
  };

  onFetchCompleteFirstBatch = (responseData) => {
    // console.log('onFetchCompleteFirstBatch called from refresh button');
    let initialFormStates = this.props.formStates;
    let contacts = getContacts(responseData.contacts, responseData.cocStatus);
    if (responseData.contacts) {
      let initFields = {};
      Object.keys(initialFormStates).map((ele) => {
        if (
          ele.startsWith("contactId_") ||
          ele.startsWith("prefix_") ||
          ele.startsWith("suffix_") ||
          ele.startsWith("firstName_") ||
          ele.startsWith("lastName_") ||
          ele.startsWith("mainContactType_") ||
          ele.startsWith("active_") ||
          ele.startsWith("certification_") ||
          ele.startsWith("phone_") ||
          ele.startsWith("email_") ||
          ele.startsWith("jobRole_") ||
          ele.startsWith("preferredLanguage_") ||
          ele.startsWith("additionalContactType_")
        ) {
          initialFormStates[ele] = null;
        }
      });
      initFields = {
        ...initialFormStates,
        ...contacts.retObj,
        hasCoc: responseData.hasCoc ? responseData.hasCoc : false,
        noOfContacts: responseData.noOfContacts
          ? parseInt(responseData.noOfContacts)
          : parseInt(this.state.noOfContacts),
        contact_suffix: contacts.contact_suffix,
        cocStatus: responseData.cocStatus,
      };
      this.props.initialize(initFields);
      this.setState({
        isLoading: false,
        contact_suffix: contacts.contact_suffix,
        noOfContacts: responseData.noOfContacts
          ? parseInt(responseData.noOfContacts)
          : parseInt(this.state.noOfContacts),
        hasCoc: responseData.hasCoc ? responseData.hasCoc : false,
        currentPage: 1,
      });
      this.updateHasCocValidationStatus(responseData.hasCoc);
    } else
      this.setState({
        isLoading: false,
        contact_suffix: contacts.contact_suffix,
      });
  };

  onFetchComplete = (responseData) => {
    let initialFormStates = this.props.formStates;
    let contacts = getContacts(
      responseData.contacts,
      initialFormStates.cocStatus
    );
    // Object.keys(contacts.retObj).map(name => {
    //     this.props.change(name, contacts.retObj[name]);
    //     return null;
    // });
    if (responseData.contacts) {
      let initFields = {};
      Object.keys(initialFormStates).map((ele) => {
        if (
          ele.startsWith("contactId_") ||
          ele.startsWith("prefix_") ||
          ele.startsWith("suffix_") ||
          ele.startsWith("firstName_") ||
          ele.startsWith("lastName_") ||
          ele.startsWith("mainContactType_") ||
          ele.startsWith("active_") ||
          ele.startsWith("certification_") ||
          ele.startsWith("phone_") ||
          ele.startsWith("email_") ||
          ele.startsWith("jobRole_") ||
          ele.startsWith("preferredLanguage_") ||
          ele.startsWith("additionalContactType_")
        ) {
          initialFormStates[ele] = null;
        }
      });
      initFields = {
        ...initialFormStates,
        ...contacts.retObj,
        currentPage: this.state.currentPage,
      };
      this.props.initialize(initFields);
      this.setState({
        isLoading: false,
        contact_suffix: contacts.contact_suffix,
        noOfContacts: responseData.noOfContacts
          ? parseInt(responseData.noOfContacts)
          : parseInt(this.state.noOfContacts),
      });
    } else
      this.setState({
        isLoading: false,
        contact_suffix: contacts.contact_suffix,
      });
  };

  generateAdditionalContactFields = (counter) => {
    let contactSection1 = [];
    let resetData = {};
    let section10 = JSON.parse(JSON.stringify(formFields.section10));
    section10.map((obj) => {
      obj.name = obj.name + "_" + counter;
      if (
        obj.name === "active_" + counter &&
        this.props.formStates &&
        this.props.formStates["mainContactType_" + counter] === "Other"
      ) {
        obj.hide = false;
      }
      resetData[obj.name] =
        this.props.formStates && this.props.formStates[obj.name]
          ? this.props.formStates[obj.name]
          : null;
      contactSection1.push(obj);
      return obj;
    });
    let contactSection2 = [];
    let section11 = JSON.parse(JSON.stringify(formFields.section11));
    section11.map((obj) => {
      obj.name = obj.name + "_" + counter;
      if (
        obj.name === "email_" + counter &&
        this.props.formStates &&
        this.props.formStates["contactId_" + counter]
      ) {
        obj.disabled = true;
      }
      resetData[obj.name] =
        this.props.formStates && this.props.formStates[obj.name]
          ? this.props.formStates[obj.name]
          : null;
      contactSection2.push(obj);
      return obj;
    });
    return {
      contactSection1: contactSection1,
      contactSection2: contactSection2,
      resetData: resetData,
    };
  };

  popupValidation = (name, value) => {
    let popupValidation = this.state.popupValidation;
    popupValidation[name] = value;
    this.setState({ popupValidation: popupValidation });
    this.forceUpdate();
  };

  popupContactSave = () => {
    let body = {};
    this.state.contactSection1.map((obj) => {
      body[obj.name.split("_")[0]] = this.props.formStates[obj.name];
      return null;
    });
    this.state.contactSection2.map((obj) => {
      body[obj.name.split("_")[0]] = this.props.formStates[obj.name];
      return null;
    });
    body["additionalContactType"] = body["additionalContactType"].join(";");
    if (Boolean(body["certification"]))
      body["certification"] = body["certification"].join(";");
    // additionalContactSection1
    if (this.state.popupMode === "editContact") {
      this.props.is_saving(true);
      this.props.connector.updateContact(
        this.onContactSaveComplete,
        body,
        this.props.formStates["accountId"],
        this.props.formStates["contactId_" + this.state.current_item.toString()]
      );
    } else if (this.state.popupMode === "addContact") {
      body["mainContactType"] = "Other";
      this.props.is_saving(true);
      this.props.connector.createContact(
        this.onContactSaveComplete,
        body,
        this.props.formStates["accountId"]
      );
    }
  };

  onContactSaveComplete = (response) => {
    if (response.contactId) {
      let page = this.state.currentPage;
      let totalContacts = this.state.noOfContacts;
      if (this.state.popupMode === "addContact") {
        totalContacts = this.state.noOfContacts + 1;
      }
      this.setState({
        popupMode: null,
        noOfContacts: totalContacts,
        isLoading: true,
      });
      this.props.connector.fetchContacts(
        this.onFetchComplete,
        this.props.partnerData.partnerInfo.accountId,
        { page: page - 1, size: this.maxPageSize }
      );
    } else {
      if (response.errorCode) {
        toastPartnerApiFailure(response);
      }
    }
    this.props.is_saving(false);
  };

  popupContactCancel = () => {
    this.state.contactSection1.map((obj) => {
      this.props.dispatch(unregisterField("uplevelRenewal", obj.name));
      this.props.change(obj.name, this.state.resetData[obj.name]);
      if (this.state.popupMode === "addContact") {
        this.props.untouch(obj.name);
      }
      return null;
    });
    this.state.contactSection2.map((obj) => {
      this.props.dispatch(unregisterField("uplevelRenewal", obj.name));
      this.props.change(obj.name, this.state.resetData[obj.name]);
      // if (this.state.popupMode === "editContact" && obj.name.startsWith('preferredLanguage') && this.props.formStates["email_" + this.state.current_item] && this.props.formStates["email_" + this.state.current_item].toLowerCase() === window.adobeIMS.getUserProfile().email.toLowerCase()) {
      //     this.props.setLang(this.state.resetData[obj.name]);
      // }
      if (this.state.popupMode === "addContact") {
        this.props.untouch(obj.name);
      }
      return null;
    });

    this.setState({ popupMode: null });
  };

  onPageChange(page) {
    this.setState({ currentPage: page, isLoading: true });
    this.props.connector.fetchContacts(
      this.onFetchComplete,
      this.props.partnerData.partnerInfo.accountId,
      { page: page - 1, size: this.maxPageSize }
    );
  }

  confirmContactDelete = () => {
    this.props.is_saving(true);
    this.props.connector.deleteContact(
      this.onContactDeleteComplete,
      this.props.formStates["accountId"],
      this.props.formStates["contactId_" + this.state.current_item.toString()]
    );
  };

  onContactDeleteComplete = (response) => {
    if (response.isError) {
      toastPartnerApiFailure(response);
    } else {
      let page = this.state.currentPage;
      let totalContacts = this.state.noOfContacts - 1;
      this.setState({
        popupMode: null,
        noOfContacts: totalContacts,
        isLoading: true,
      });
      this.props.connector.fetchContacts(
        this.onFetchComplete,
        this.props.partnerData.partnerInfo.accountId,
        { page: (page - 1) * this.maxPageSize, size: this.maxPageSize }
      );
    }
    this.props.is_saving(false);
  };

  fetchContacts = () => {
    // console.log('calling fetchContacts from Refresh');
    this.setState({ isLoading: true });
    this.props.connector.fetchContacts(
      this.onFetchCompleteFirstBatch,
      this.props.partnerData.partnerInfo.accountId,
      { page: 0, size: this.maxPageSize }
    );
  };

  render() {
    if (!this.props.isSaveAndExit) {
      const formName = "uplevelRenewal";
      this.props.onValidateChange(
        Object.values(this.state.sectionValidation).every(Boolean)
      );
      const tableBody = [];
      {
        this.state.contact_suffix?.map((item) => {
          if (Boolean(this.props.formStates["email_" + item])) {
            if (!this.isCOCValidateRequired) {
              let courseCompleted = null;
              if (this.props.formStates["certification_" + item])
                courseCompleted =
                  this.props.formStates["certification_" + item].join(", ");
              tableBody.push(
                <TR key={"contact_" + item}>
                  <TD style={{ fontWeight: "bold" }}>
                    {this.props.formStates["firstName_" + item] +
                      " " +
                      this.props.formStates["lastName_" + item]}
                  </TD>
                  <TD>{this.props.formStates["mainContactType_" + item]}</TD>
                  <TD>{this.props.formStates["email_" + item]}</TD>
                  <TD>{courseCompleted}</TD>
                  <TD>
                    <div style={{ display: "inline-flex" }}>
                      <Button
                        onClick={() => {
                          this.setState({
                            popupMode: "editContact",
                            ...this.generateAdditionalContactFields(item),
                            current_item: item,
                          });
                        }}
                        variant="primary"
                      >
                        <Translate value="uplevelRenewal.ConsolePartnerBtnEdit" />
                      </Button>
                      <Button
                        onClick={() => {
                          this.setState({
                            popupMode: "delete",
                            current_item: item,
                          });
                        }}
                        disabled={
                          this.props.formStates["mainContactType_" + item] ===
                            "Secondary" ||
                          this.props.formStates["mainContactType_" + item] ===
                            "Primary"
                        }
                        variant="warning"
                      >
                        <Translate value="uplevelRenewal.QBPDelete" />
                      </Button>
                    </div>
                  </TD>
                </TR>
              );
            } else if (
              this.isCOCValidateRequired &&
              Boolean(this.props.formStates["cocStatus_" + item])
            ) {
              tableBody.push(
                <TR key={"contact_" + item}>
                  <TD style={{ fontWeight: "bold" }}>
                    {this.props.formStates["firstName_" + item] +
                      " " +
                      this.props.formStates["lastName_" + item]}
                  </TD>
                  <TD>{this.props.formStates["mainContactType_" + item]}</TD>
                  <TD>{this.props.formStates["email_" + item]}</TD>
                  <TD>{this.props.formStates["cocStatus_" + item]}</TD>
                </TR>
              );
            }
          }
          return null;
        });
      }

      return (
        <div>
          {this.state.popupMode ? (
            <div className="overlay" style={{ zIndex: "2" }}></div>
          ) : null}
          <Grid>
            <GridRow>
              <GridColumn size={[12, 10, 8, 8]} offsetSize={[0, 1, 2, 2]}>
                <GridRow>
                  <GridColumn>
                    <Heading className="textBold" variant="pageTitle">
                      <Translate value="uplevelRenewal.OnbrdContactSecContactInfo" />
                    </Heading>
                    <p>
                      {this.isCOCValidateRequired ||
                      (this.props.formStates.context === "Renewal" &&
                        this.props.formStates["draftLevel"] ===
                          "Registered") ? (
                        <Translate value="registration.OnbrdContactSectionHeader" />
                      ) : (
                        <Translate value="uplevelRenewal.OnbrdCertContactSectionHeader" />
                      )}
                    </p>
                  </GridColumn>
                </GridRow>

                <GridRow
                  style={{ "padding-top": "1%", "padding-bottom": "3%" }}
                >
                  <GridColumn size={[12, 12, 12, 12]}>
                    {!this.isCOCValidateRequired && (
                      <GridRow>
                        <GridColumn>
                          <Button
                            className="button-action margin-action"
                            variant="cta"
                            onClick={() => {
                              this.setState({
                                popupMode: "addContact",
                                ...this.generateAdditionalContactFields(
                                  this.state.contact_suffix.length
                                ),
                              });
                            }}
                          >
                            <Translate value="uplevelRenewal.OnbrdContactAdd" />
                          </Button>
                        </GridColumn>
                      </GridRow>
                    )}

                    {this.state.isLoading ? (
                      <div className="reassignWell">
                        <Wait size="L" />
                      </div>
                    ) : (
                      <Table>
                        <THead>
                          <TH>
                            <Translate value="uplevelRenewal.ReAssignContactNameLabel" />
                          </TH>
                          <TH>
                            <Translate value="uplevelRenewal.ConsolePartnerContactCType" />
                          </TH>
                          <TH>
                            <Translate value="uplevelRenewal.ConsolePartnerContactEmail" />
                          </TH>
                          <TH>
                            {this.isCOCValidateRequired ? (
                              <Translate value="uplevelRenewal.course_completed_COC" />
                            ) : (
                              <Translate value="uplevelRenewal.course_completed" />
                            )}
                          </TH>
                        </THead>

                        <TBody>{tableBody}</TBody>
                      </Table>
                    )}
                  </GridColumn>
                </GridRow>
                <GridRow align="center">
                  <GridColumn>
                    <Pagination
                      style={{ display: "inline-flex" }}
                      className="section-heading"
                      defaultPage={1}
                      mode="primary"
                      currentPage={this.state.currentPage}
                      onChange={(e) => {
                        this.onPageChange(e);
                      }}
                      onNext={() => {
                        this.onPageChange(this.state.currentPage + 1);
                      }}
                      onPrevious={() => {
                        this.onPageChange(this.state.currentPage - 1);
                      }}
                      totalPages={Math.ceil(
                        this.state.noOfContacts / this.maxPageSize
                      )}
                      variant="explicit"
                    />
                  </GridColumn>
                </GridRow>
                {this.isCOCValidateRequired &&
                  this.state.hasCoc == false &&
                  !this.state.isLoading && (
                    <>
                      <GridRow>
                        <GridColumn>
                          <p>
                            <a
                              href={window.apcConfig.partner.cpLink}
                              target="_blank"
                              className="cpLoginLink"
                            >
                              <Button variant="cta">
                                <Translate value="uplevelRenewal.logInCPButton" />
                              </Button>
                            </a>
                          </p>
                        </GridColumn>
                      </GridRow>
                      <GridRow>
                        <GridColumn size={[12, 12, 12, 12]}>
                          <p className="errorColorRed">
                            <Translate value="uplevelRenewal.errorForNoCOC_1" />
                            <a
                              href={window.apcConfig.partner.cpLink}
                              target="_blank"
                              className="errorColorRed"
                            >
                              <Translate value="uplevelRenewal.errorForNoCOC_2" />
                            </a>
                            <Translate value="uplevelRenewal.errorForNoCOC_3" />
                          </p>
                        </GridColumn>
                        <GridColumn size={[12, 12, 12, 12]}>
                          <Button
                            className="button-action margin-action"
                            variant="cta"
                            onClick={() => this.fetchContacts()}
                          >
                            <Translate value="uplevelRenewal.refresh" />
                          </Button>
                        </GridColumn>
                      </GridRow>
                    </>
                  )}
                <GridRow>
                  <GridColumn>
                    {this.state.popupMode === "editContact" ||
                    this.state.popupMode === "addContact" ? (
                      <Dialog
                        className="customDialog"
                        variant="confirmation"
                        title={
                          this.state.popupMode === "editContact" ? (
                            <Translate value="uplevelRenewal.ConsolePartnerBtnEdit" />
                          ) : !this.isCOCValidateRegion ? (
                            <Translate value="registration.add_additional_contacts" />
                          ) : (
                            <Translate value="uplevelRenewal.add_certified_contacts" />
                          )
                        }
                        confirmLabel={
                          <Translate value="uplevelRenewal.TrngSaveClose" />
                        }
                        onConfirm={() => {
                          this.popupContactSave();
                        }}
                        onCancel={() => {
                          this.popupContactCancel();
                        }}
                        confirmDisabled={
                          !Object.values(this.state.popupValidation).every(
                            Boolean
                          )
                        }
                        cancelLabel={
                          <Translate value="uplevelRenewal.TrngClose" />
                        }
                      >
                        <GridColumn>
                          <Provider store={store}>
                            <GridRow>
                              <GridColumn size={[12, 12, 12, 12]}>
                                <p>
                                  {this.isCOCValidateRequired ||
                                  (this.props.formStates.context ===
                                    "Renewal" &&
                                    this.props.formStates["draftLevel"] ===
                                      "Registered") ? (
                                    <Translate value="registration.msg_add_contact_1" />
                                  ) : (
                                    <Translate value="uplevelRenewal.add_certified_msg" />
                                  )}
                                </p>
                              </GridColumn>
                            </GridRow>
                            <GridRow>
                              <GridColumn size={[12, 6, 6, 6]}>
                                <DataSection
                                  formStates={this.props.formStates}
                                  form={formName}
                                  sectionName="contact1"
                                  updateValidation={this.popupValidation}
                                  field={this.state.contactSection1}
                                />
                              </GridColumn>
                              <GridColumn size={[12, 6, 6, 6]}>
                                <DataSection
                                  formStates={this.props.formStates}
                                  form={formName}
                                  sectionName="contact2"
                                  updateValidation={this.popupValidation}
                                  field={this.state.contactSection2}
                                />
                              </GridColumn>
                            </GridRow>
                          </Provider>
                        </GridColumn>
                      </Dialog>
                    ) : null}
                  </GridColumn>
                </GridRow>

                <GridRow>
                  <GridColumn>
                    {Boolean(this.state.popupMode === "delete") ? (
                      <Dialog
                        className="customDialog"
                        variant="confirmation"
                        title={
                          <Translate value="uplevelRenewal.confirm_deletion" />
                        }
                        confirmLabel={
                          <Translate value="uplevelRenewal.QBPDelete" />
                        }
                        onConfirm={() => {
                          this.confirmContactDelete();
                        }}
                        onCancel={() => {
                          this.setState({ popupMode: null });
                        }}
                        cancelLabel={
                          <Translate value="uplevelRenewal.TrngClose" />
                        }
                      >
                        <Translate value="uplevelRenewal.delete_confirm_msg" />{" "}
                        {
                          this.props.formStates[
                            "firstName_" + this.state.current_item
                          ]
                        }{" "}
                        {
                          this.props.formStates[
                            "lastName_" + this.state.current_item
                          ]
                        }{" "}
                        <Translate value="uplevelRenewal.delete_confirm_msg1" />
                      </Dialog>
                    ) : null}
                  </GridColumn>
                </GridRow>
              </GridColumn>
            </GridRow>
          </Grid>
        </div>
      );
    } else return <SaveNExit />;
  }
}

AddContacts = reduxForm({
  form: "uplevelRenewal",
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AddContacts);
function mapStateToProps(state) {
  return {
    formStates: getFormValues("uplevelRenewal")(state), // here 'form' is the name you have given your redux form
    isCOCValidateRequired: state.uplevelRenewal.isCOCValidateRequired,
  };
}
export default connect(mapStateToProps)(AddContacts);
